import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import orderReducer from './order/orderSlice';
import paymentReducer from './payment/paymentSlice';
import userReducer from './user/userSlice';
import installmentsReducer from './installments/installmentsSlice';

export const store = configureStore({
  reducer: {
    order: orderReducer,
    payment: paymentReducer,
    user: userReducer,
    installments: installmentsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
